import { DestroyRef, Directive, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[number]',
})
export class NumberDirective {
  private ngControl = inject(NgControl);
  private destroyRef = inject(DestroyRef);

  constructor() {}

  ngAfterViewInit(): void {
    this.ngControl.valueChanges
      ?.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: string) => {
        if (value == null || typeof value === 'number') {
          return;
        }

        value = value.replaceAll(',', '.');
        let decimalIndex: number = value.indexOf('.', 1);

        let initialValue = value.replace(/[^0-9]/g, '');

        if (decimalIndex != -1) {
          initialValue =
            initialValue.substring(0, decimalIndex) +
            '.' +
            initialValue.substring(decimalIndex);
        }

        if (value !== initialValue) {
          this.ngControl.control?.setValue(initialValue, { emitEvent: false });
        }
      });
  }
}
